var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v(_vm._s(_vm.$t("not_found")))]),_c('p',[_vm._v(_vm._s(_vm.$t("not_found_more")))]),_c('p',[_c('router-link',{staticClass:"btn btn-primary",attrs:{"to":"/"}},[_vm._v(_vm._s(_vm.$t("back")))])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }